import { Route, Routes, Navigate } from "react-router-dom";
import InicioView from "../pages/Privada/Inicio/Inicio.View";
import MinhaContaView from "../pages/Privada/MinhaConta/MinhaConta.View";
import LoginView from "../pages/Publica/Login/Login.View";
import NaoEncontrada from "../pages/Publica/NaoEncontrada/NaoEncontrada.View";
import SignInView from "../pages/Publica/SignIn/SignIn.View";
import { PrivateRoute } from "./PrivateRoute";
import { renderRoutes } from "src/hook/renderRoutes";
import { NFeRoutes } from "src/pages/Privada/Fiscal/NFe/NFe.Routes";
import { EstoqueRoutes } from "src/pages/Privada/Estoque/EstoqueRoutes";
import { NFCeRoutes } from "src/pages/Privada/Fiscal/NFCe/NFCeRoutes";
import { TributacaoRoutes } from "src/pages/Privada/Fiscal/Tributacao/TributacaoRoutes";
import { EntidadeRoutes } from "src/pages/Privada/Entidade/EntidadeRoutes";
import { ConfiguracoesRoutes } from "src/pages/Privada/Configuracoes/ConfiguracoesRoute";
import { RelatorioRoutes } from "src/pages/Privada/Sistema/Relatorio/RelatorioRoute";
import ConfirmarEmailView from "src/pages/Publica/ConfirmarEmail/ConfirmarEmail.View";

export const Rotas = () => (
  <Routes>
    <Route path="/" element={<PrivateRoute />}>
      <Route index element={<Navigate to="/inicio" replace />} />
      <Route path="/inicio" element={<InicioView />} />
      <Route path="/minhaconta" element={<MinhaContaView />} />
      {renderRoutes(EntidadeRoutes)}
      {renderRoutes(NFeRoutes)}
      {renderRoutes(NFCeRoutes)}
      {renderRoutes(EstoqueRoutes)}
      {renderRoutes(TributacaoRoutes)}
      {renderRoutes(ConfiguracoesRoutes)}
      {renderRoutes(RelatorioRoutes)}
    </Route>
    <Route path="/cadastro" element={<SignInView />} />
    <Route path="/login" element={<LoginView />} />
    <Route path="/confirmar-email" element={<ConfirmarEmailView />} />
    <Route path="*" element={<NaoEncontrada />} />
  </Routes>
);
